module.exports = __webpack_public_path__ + "static/img/bgimg4-4.e5d609a0.png";